import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import { UPLOAD_FOLDER_NAME } from '@plugins/shared/constants';

import { BLOB_CDN_ENDPOINT } from './auth.const';
import { AuthService } from './auth.service';
import { assertBlobConfig } from './utils';

@Pipe({
  name: 'onBlobStorage',
  standalone: true,
})
export class BlobStoragePipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);
  private readonly auth = inject(AuthService);
  private readonly blobCDNEndpoint = inject(BLOB_CDN_ENDPOINT);

  public transform(value: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(this.build(value));
  }

  public build(value: string): string {
    assertBlobConfig(this.auth.blob);
    const { url, sas } = value.startsWith(`${UPLOAD_FOLDER_NAME}/`)
      ? this.auth.blob.upload
      : this.auth.blob.download;
    return `${this.blobCDNEndpoint || url}/${value}?${sas}`;
  }
}
